import { AbstractControl, AsyncValidatorFn, ValidationErrors } from "@angular/forms";
import { Observable } from "rxjs";

import { AccountService } from "../services/account.service";

export class PromoCodeValidator {

  static createValidator(accountService: AccountService): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return accountService.checkPromoCode(control.value);
    };
  }
}
